'use strict';

var react = require('react');
var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var noop = require('@userzoomlibraries/toolkit-js-utils/noop');
var isDefinedAndNotNull = require('@userzoomlibraries/toolkit-js-utils/is-defined-and-not-null');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);
var noop__default = /*#__PURE__*/_interopDefaultCompat(noop);
var isDefinedAndNotNull__default = /*#__PURE__*/_interopDefaultCompat(isDefinedAndNotNull);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useInterval = function useInterval() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop__default["default"];
  var intervalDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var startInmediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var intervalIdRef = react.useRef(null);

  var _useState = react.useState(startInmediate),
      _useState2 = _slicedToArray(_useState, 2),
      isRunning = _useState2[0],
      setIsRunning = _useState2[1];

  var start = function start() {
    if (!isRunning) {
      setIsRunning(true);
    }
  };

  var stop = function stop() {
    if (isRunning) {
      setIsRunning(false);
    }
  };

  react.useEffect(function () {
    var executeCallback = function executeCallback() {
      callback();
    };

    if (isDefinedAndNotNull__default["default"](intervalDuration) && isRunning) {
      var intervalId = setInterval(executeCallback, intervalDuration);
      intervalIdRef.current = intervalId;
      return function () {
        intervalIdRef.current = null;
        clearInterval(intervalId);
      };
    }

    return noop__default["default"];
  }, [intervalDuration, isRunning, callback]);
  return {
    start: start,
    stop: stop,
    intervalId: intervalIdRef.current
  };
};

useInterval.HOOK_ID = 'Gearz.ReactHooks.useInterval';
useInterval.returnType = PropTypes__default["default"].shapeWithDescription({
  start: PropTypes__default["default"].funcWithDescription('Function to start the interval.'),
  stop: PropTypes__default["default"].funcWithDescription('Function to stop the interval.'),
  intervalId: PropTypes__default["default"].numberWithDescription('Id of the interval.')
}, 'Information of the interval.');
useInterval.parameterTypes = {
  callback: PropTypes__default["default"].funcWithDescription('Callback to execute in the interval.'),
  intervalDuration: PropTypes__default["default"].numberWithDescription('Duration of the interval. (in milliseconds)'),
  startInmediate: PropTypes__default["default"].boolWithDescription('Flag to start the interval inmediately.')
};
useInterval.defaultParameters = {
  callback: noop__default["default"],
  intervalDuration: 100,
  startInmediate: false
};

module.exports = useInterval;
